import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Form, FormFeedback, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from 'reactstrap';
import { Show } from '../../components';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import Required from './Required';
import PropTypes from 'prop-types';
import { findAllFSCs, save } from './api';
import history from '../../store/history';
import { CORPORATE_LEAD_LIST } from '../../Routes';
import * as _ from 'lodash';
import { SET_MESSAGE } from '../../actions/utils';
import { CORPORATE_LEAD_ERRORS } from './New';
import axios from 'axios';

const propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  onChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  readOnly: PropTypes.bool,
  FSCList: PropTypes.array,
  DOBList: PropTypes.array,
  hrmList: PropTypes.array,
  branch: PropTypes.object,
  office: PropTypes.object,
};

const CorporateLeadForm = (props) => {
  const values = props?.values;
  const errors = props?.errors;
  const touched = props?.touched;
  const onChange = props?.handleChange;
  const setFieldValue = props?.setFieldValue;
  const onBlur = props?.handleBlur;
  const readOnly = props?.readOnly;
  const managers = useSelector(
    (state) =>
      state?.lookup?.managers?.map((e) => ({
        value: e?.agentId,
        label: `${e.agentName} (${e.businessCd})`,
      })) || []
  );
  const dispatch = useDispatch();
  const hideSaveDraft = (values?.seq && !values?.draft) || !values?.taxCode;
  const username = useSelector((state) => state?.auth?.principal);
  const [FSCList, setFSCList] = useState(props.FSCList || []);
  const [bankLeaderList, setBankLeaderList] = useState([]);
  const bank = useSelector((state) => state?.lookup?.bank);

  useEffect(() => {
    let bankStaffCode = values?.bankStaffCode;
    if (bankStaffCode) {
      axios.get(`/api/lookup/managers?code=${bankStaffCode}`).then((response) =>
        setBankLeaderList(
          response?.data?.map((e) => {
            return { value: e.agentId, label: `${e.agentName} (${e.businessCd})` };
          })
        )
      );
    } else {
      setBankLeaderList(managers);
    }
  }, [values?.bankStaffCode]);

  useEffect(() => {
    let branchCode = values?.bankOfficeCode;
    if (branchCode) {
      findAllFSCs(branchCode).then((response) => {
        setFSCList(response?.data?.content?.map((e) => ({ label: e.fsc_name, value: e.fsc_code })));
      });
    }
  }, [values?.bankOfficeCode]);

  return (
    <Form onSubmit={props.handleSubmit}>
      <div className='h3 text-primary text-uppercase'>Khách hàng doanh nghiệp</div>

      <Show if={bank !== 'VCB'}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label htmlFor='companyName'>
                Tên doanh nghiệp <Required />
              </Label>
              <Input
                id='companyName'
                name='companyName'
                value={values?.companyName}
                onChange={onChange}
                onBlur={onBlur}
                invalid={touched?.companyName && !!errors?.companyName}
                readOnly={readOnly}
              />
              <FormFeedback>{errors.companyName}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label htmlFor='taxCode'>
                Mã số thuế <Required />
              </Label>
              <Input
                id='taxCode'
                name='taxCode'
                value={values.taxCode}
                onChange={onChange}
                onBlur={onBlur}
                invalid={touched?.taxCode && !!errors?.taxCode}
                readOnly={readOnly}
              />
              <FormFeedback>{props.errors.taxCode}</FormFeedback>
            </FormGroup>
          </Col>
        </Row> 

        <Row>
          <Col sm={12}>
            <FormGroup check>
              <Label check>
                <Input
                  type='checkbox'
                  name='consent'
                  readOnly={props.readOnly}
                  checked={props.values.consent === 'Y'}
                  invalid
                  onChange={() => {
                    if (props.readOnly) return;
                    let value = props.values.consent ? '' : 'Y';
                    props.handleChange({
                      target: {
                        name: 'consent',
                        value,
                      },
                    });
                  }}
                />{' '}
                <span className={classnames({ 'text-danger': !!props.errors.consent })}>
                  Khách hàng với những thông tin trên đồng ý cho phép Nhân viên tư vấn tài chính của FWD tiếp cận để
                  giới thiệu các sản phẩm của FWD
                </span>
              </Label>
            </FormGroup>
          </Col>
        </Row>

        <Show if={!props.readOnly}>
          <Row className='pt-3'>
            <Col sm={12}>
              <Button color='primary' type='submit' disabled={!props.dirty || !props.isValid || props.isSubmitting}>
                Gửi
              </Button>
            </Col>
          </Row>
        </Show>
      </Show>

      <Show if={bank === 'VCB'}>
        <fieldset>
          <legend>Phần thông tin nội bộ</legend>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label htmlFor='productCode'>
                  Loại sản phẩm <Required />
                </Label>
                <Input
                  id='productCode'
                  name='productCode'
                  type='select'
                  value={values?.productCode}
                  onChange={(e) => {
                    onChange(e);
                    if (!readOnly) {
                      setFieldValue('agentCode', '', true);
                      setFieldValue('employeeCode', '', true);
                    }
                  }}
                  onBlur={onBlur}
                  invalid={touched?.productCode && !!errors?.productCode}
                  disabled={readOnly}
                >
                  <option value=''>Chọn...</option>
                  <option value='IFWD'>Bộ 3 Bảo Vệ (iFWD)</option>
                  {/* Changed according to ticket: https://hethong-int.fwd.com.vn/jira/browse/BLT-311 */}
                  {/* 
                    <option value='UL'>FWD Đón đầu thay đổi 3.0</option>
                    <option value='UL_ORG'>FWD Đón đầu thay đổi 3.0 – Doanh nghiệp</option>
                    <option value='IL'>FWD Nâng tầm vị thế</option> 
                  */}
                </Input>
                <FormFeedback>{errors?.productCode}</FormFeedback>
              </FormGroup>
            </Col>

            <Show if={values?.productCode !== 'IFWD'}>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='employeeCode'>
                    DOB/RDOB <Required />
                  </Label>
                  <InputGroup>
                    <Input
                      id='employeeCode'
                      name='employeeCode'
                      type='select'
                      value={values?.employeeCode}
                      onChange={onChange}
                      onBlur={onBlur}
                      invalid={touched?.employeeCode && !!errors?.employeeCode}
                      disabled={readOnly}
                    >
                      <option value=''>Chọn...</option>
                      {props.DOBList?.map((e) => (
                        <option key={e.value} value={e.value}>
                          {e.label}
                        </option>
                      ))}
                    </Input>
                    <Show if={!!values?.employeeCode}>
                      <InputGroupAddon addonType='append'>
                        <Button type='button' color='dark'>
                          Mã: {values?.employeeCode}
                        </Button>
                      </InputGroupAddon>
                    </Show>
                  </InputGroup>
                  <FormFeedback>{errors?.employeeCode}</FormFeedback>
                </FormGroup>
              </Col>
            </Show>

            <Show if={values?.productCode === 'IFWD' || values?.employeeCode === username}>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='agentCode'>
                    FSC <Required />
                  </Label>
                  <InputGroup>
                    <Input
                      id='agentCode'
                      name='agentCode'
                      type='select'
                      value={values?.agentCode}
                      onChange={onChange}
                      onBlur={onBlur}
                      invalid={touched?.agentCode && !!errors?.agentCode}
                      disabled={values?.nbwseq}
                    >
                      <option value=''>Chọn...</option>zz
                      {FSCList?.map((e) => (
                        <option key={e.value} value={e.value}>
                          {e.label}
                        </option>
                      ))}
                    </Input>
                    <Show if={!!values?.agentCode}>
                      <InputGroupAddon addonType='append'>
                        <Button type='button' color='dark'>
                          Mã: {values?.agentCode}
                        </Button>
                      </InputGroupAddon>
                    </Show>
                  </InputGroup>
                  <FormFeedback>{errors?.agentCode}</FormFeedback>
                </FormGroup>
              </Col>
            </Show>

            <Col md={6}>
              <FormGroup>
                <Label>Chi nhánh</Label>
                <InputGroup>
                  <Input value={props?.office?.name} readOnly />
                  <Show if={props?.office?.bizCode}>
                    <InputGroupAddon addonType='append'>
                      <Button type='button' color='dark'>
                        Mã: {props?.office?.bizCode}
                      </Button>
                    </InputGroupAddon>
                  </Show>
                </InputGroup>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Phòng</Label>
                <InputGroup>
                  <Input value={props?.branch?.name} readOnly />
                  <Show if={props?.branch?.bizCode}>
                    <InputGroupAddon addonType='append'>
                      <Button type='button' color='dark'>
                        Mã: {props?.branch?.bizCode}
                      </Button>
                    </InputGroupAddon>
                  </Show>
                </InputGroup>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label htmlFor='bankIntroducerCode'>Mã người giới thiệu </Label>
                <Input
                  id='bankIntroducerCode'
                  name='bankIntroducerCode'
                  value={values?.bankIntroducerCode}
                  onChange={onChange}
                  onBlur={onBlur}
                  readOnly={readOnly}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label htmlFor='bankIntroducerCode'>
                  Mã lãnh đạo phòng <Required />
                </Label>
                <Input
                  id='bankLeaderCode'
                  name='bankLeaderCode'
                  type='select'
                  value={values?.bankLeaderCode}
                  onChange={onChange}
                  onBlur={onBlur}
                  invalid={touched?.bankLeaderCode && !!errors?.bankLeaderCode}
                  disabled={readOnly}
                >
                  <option value={''}>Chọn...</option>
                  {bankLeaderList?.map((e) => (
                    <option key={e.value} value={e.value}>
                      {e.label}
                    </option>
                  ))}
                </Input>
                <FormFeedback>{errors?.bankLeaderCode}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </fieldset>

          <fieldset>
            <legend>Phần thông tin khách hàng</legend>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyName'>
                    Tên công ty <Required />
                  </Label>
                  <Input
                    id='companyName'
                    name='companyName'
                    value={values?.companyName}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.companyName && !!errors?.companyName}
                    readOnly={readOnly}
                  />
                  <FormFeedback>{errors.companyName}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='taxCode'>
                    Mã số thuế <Required />
                  </Label>
                  <Input
                    id='taxCode'
                    name='taxCode'
                    value={values.taxCode}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.taxCode && !!errors?.taxCode}
                    readOnly={readOnly}
                  />
                  <FormFeedback>{props.errors.taxCode}</FormFeedback>
                </FormGroup>
              </Col>

              {/* Changed according to ticket: https://hethong-int.fwd.com.vn/jira/browse/BLT-311 */}
              {/* 
              <Show if={bank !== 'VCB'}>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor='companySector'>
                      Ngành nghề <Required />
                    </Label>
                    <Input
                      id='companySector'
                      name='companySector'
                      type='select'
                      value={values.companySector}
                      onChange={onChange}
                      onBlur={onBlur}
                      invalid={touched?.companySector && !!errors?.companySector}
                      disabled={readOnly}
                    >
                      <option value=''>Chọn...</option>
                      <option value='i'>Sản xuất</option>
                      <option value='ii'>Xây dựng</option>
                      <option value='iii'>Thương mại</option>
                      <option value='iv'>Ẩm thực, nhà hàng & ăn uống</option>
                      <option value='v'>Vận tải</option>
                      <option value='vi'>Tài chính</option>
                      <option value='vii'>Dịch vụ</option>
                      <option value='viii'>Khác</option>
                    </Input>
                    <FormFeedback>{errors.companySector}</FormFeedback>
                  </FormGroup>

                  <Show if={values?.companySector === 'viii'}>
                    <FormGroup>
                      <Input
                        id='companySectorNote'
                        name='companySectorNote'
                        type='textarea'
                        value={values?.companySectorNote}
                        onChange={onChange}
                        onBlur={onBlur}
                        invalid={touched?.companySectorNote && !!errors?.companySectorNote}
                        disabled={readOnly}
                      />
                      <FormFeedback>{errors?.companySectorNote}</FormFeedback>
                    </FormGroup>
                  </Show>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor='companyType'>
                      Loại hình công ty <Required />
                    </Label>
                    <Input
                      id='companyType'
                      name='companyType'
                      type='select'
                      value={values.companyType}
                      onChange={onChange}
                      onBlur={onBlur}
                      invalid={touched?.companyType && !!errors?.companyType}
                    disabled={readOnly}
                  >
                    <option value=''>Chọn...</option>
                    <option value='PRIVATE'>Doanh nghiệp tư nhân</option>
                    <option value='STATE-OWNED'>Doanh nghiệp nhà nước</option>
                    <option value='FDI'>Doanh nghiệp FDI</option>
                  </Input>
                  <FormFeedback>{props.errors.companyType}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyEmployees'>
                    Số lượng nhân viên <Required />
                  </Label>
                  <Input
                    id='companyEmployees'
                    name='companyEmployees'
                    type='select'
                    value={values.companyEmployees}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.companyEmployees && !!errors?.companyEmployees}
                    disabled={readOnly}
                  >
                    <option value=''>Chọn...</option>
                    <option value='1-20'>1 - 20</option>
                    <option value='20-100'>20 - 100</option>
                    <option value='101-200'>101 - 200</option>
                    <option value='201-1000'>201 - 1000</option>
                    <option value='1000+'>&gt; 1000</option>
                  </Input>
                  <FormFeedback>{props.errors.companyEmployees}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyEmployeeIncome'>Thu nhập của nhân viên</Label>
                  <Input
                    id='companyEmployeeIncome'
                    name='companyEmployeeIncome'
                    type='select'
                    value={values.companyEmployeeIncome}
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={readOnly}
                  >
                    <option value=''>Chọn...</option>
                    <option value='0-15'>&lt; 15 triệu</option>
                    <option value='15-30'>15 - 30 triệu</option>
                    <option value='31-50'>31 - 50 triệu</option>
                    <option value='50+'>Trên 50 triệu</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyContactName'>
                    Tên người liên hệ <Required />
                  </Label>
                  <Input
                    id='companyContactName'
                    name='companyContactName'
                    value={values.companyContactName}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.companyContactName && !!errors?.companyContactName}
                    readOnly={readOnly}
                  />
                  <FormFeedback>{errors?.companyContactName}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyContactPhoneNumber'>
                    Số điện thoại người liên hệ <Required />
                  </Label>
                  <Input
                    id='companyContactPhoneNumber'
                    name='companyContactPhoneNumber'
                    value={values.companyContactPhoneNumber}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.companyContactPhoneNumber && !!errors?.companyContactPhoneNumber}
                    readOnly={readOnly}
                  />
                  <FormFeedback>{errors?.companyContactPhoneNumber}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor='companyContactJobTitle'>
                    Chức vụ người liên hệ <Required />
                  </Label>
                  <Input
                    id='companyContactJobTitle'
                    name='companyContactJobTitle'
                    type='select'
                    value={values.companyContactJobTitle}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={touched?.companyContactJobTitle && !!errors?.companyContactJobTitle}
                    disabled={readOnly}
                  >
                    <option value=''>Chọn...</option>
                    <option value='i'>Nhân viên</option>
                    <option value='ii'>Công đoàn</option>
                    <option value='iii'>Nhân sự</option>
                    <option value='iv'>Chủ doanh nghiệp</option>
                  </Input>
                  <FormFeedback>{errors?.companyContactJobTitle}</FormFeedback>
                </FormGroup>
              </Col>
            </Show> 
            */}
            
          </Row> 
        </fieldset>

        <fieldset>
          <legend>Ghi chú</legend>

          <Row>
            <Col md={12}>
              <FormGroup>
                <Input
                  id='note'
                  name='note'
                  type='textarea'
                  value={values.note}
                  onChange={onChange}
                  onBlur={onBlur}
                  readOnly={readOnly}
                />
              </FormGroup>
            </Col>
            <Col sm={12}>
              <FormGroup check>
                <Label check>
                  <Input
                    type='checkbox'
                    name='consent'
                    readOnly={props.readOnly}
                    checked={props.values.consent === 'Y'}
                    invalid
                    onChange={() => {
                      if (props.readOnly) return;
                      let value = props.values.consent ? '' : 'Y';
                      props.handleChange({
                        target: {
                          name: 'consent',
                          value,
                        },
                      });
                    }}
                  />{' '}
                  <span className={classnames({ 'text-danger': !!props.errors.consent })}>
                    Khách hàng với những thông tin trên đồng ý cho phép Nhân viên tư vấn tài chính của FWD tiếp cận để
                    giới thiệu các sản phẩm của FWD
                  </span>
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </fieldset>

        <Row className='pt-3'>
          <Col sm={12}>
            <Show if={!hideSaveDraft && !readOnly}>
              <Button
                color='primary'
                type='button'
                onClick={() => {
                  save({ ...values, draft: true })
                    .then(() => history.push(CORPORATE_LEAD_LIST))
                    .catch((err) => {
                      let errors = _.values(err.response.data).map((e) => ({
                        code: e,
                        message: CORPORATE_LEAD_ERRORS[e] || CORPORATE_LEAD_ERRORS['DEFAULT'],
                      }));
                      dispatch({ type: SET_MESSAGE, payload: 'ERROR', errors });
                    });
                }}
              >
                Lưu nháp
              </Button>{' '}
            </Show>

            <Show if={!readOnly || (!values?.nbwseq && username === values?.employeeCode && values?.agentCode)}>
              <Button color='primary' type='submit' disabled={!props.isValid || props.isSubmitting}>
                Gửi
              </Button>
            </Show>
          </Col>
        </Row>

      </Show>
    </Form>
  );
};

CorporateLeadForm.propTypes = propTypes;

export default CorporateLeadForm;
